import { Box, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import { resolve } from 'path-browserify';
import React from 'react'
import { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';
import readXlsFile from 'read-excel-file';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

class MarcasRelojMensual extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            loading: false,
            consulta: {
                mes: '',
                anio: '',
            },
            consultaRealizada: [],
            excel: false,
        }

        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioConsulta = this.manejarEnvioConsulta.bind(this);
    }
    render(){
        return (
            <>
                <h3>Marcas Manual Reloj</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                <Container>
                    <br/>
                    <div>
                    {this.state.excel ?
                        <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                        </ReactHtmlTableToExcel> : null }
                    </div>
                    {this.state.excel
                    ?
                        null
                    :
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>Mes</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.consulta.mes} onChange={this.manejarCambiosDatos}>
                                        <option value=''>MES</option>
                                        <option value={'01'}>ENERO</option>
                                        <option value={'02'}>FEBRERO</option>
                                        <option value={'03'}>MARZO</option>
                                        <option value={'04'}>ABRIL</option>
                                        <option value={'05'}>MAYO</option>
                                        <option value={'06'}>JUNIO</option>
                                        <option value={'07'}>JULIO</option>
                                        <option value={'08'}>AGOSTO</option>
                                        <option value={'09'}>SETIEMBRE</option>
                                        <option value={'10'}>OCTUBRE</option>
                                        <option value={'11'}>NOVIEMBRE</option>
                                        <option value={'12'}>DICIEMBRE</option>
                                    </select>
                                </Grid>
                                <Grid item xs={2}>
                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.consulta.anio} onChange={this.manejarCambiosDatos} type="text" />
                                </Grid>
                                <Grid item xs={2}>
                                    <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioConsulta}>Enviar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    }
                </Container>
                <Container>
                    <br/>
                    <br/>
                    {this.state.excel
                    ?
                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Reloj</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.consultaRealizada.map((dato, index) => (
                                        <StyledTableRow key={index}>
                                            <StyledTableCell>{dato}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    :
                        null
                    }
                </Container>
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            excel: false,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.consulta;
            funcionarioActualizado[clave] = valor;
            return{
                consulta: funcionarioActualizado,
            };
        })
    }

    async manejarEnvioConsulta(e){
        e.preventDefault();

        if((this.state.consulta.mes === '')){
            this.setState({
                errores: 'DEBE INDICAR EL MES!',
                notificaciones: null,
            })
        }else if((this.state.consulta.anio === '')){
            this.setState({
                errores: 'DEBE INGRESAR EL AÑO',
                notificaciones: null,
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.consulta]);

            const control = await fetch(`${Constantes.RUTA_API}/consultar_marcasMensualReloj.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
            });
            if(res[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    consultaRealizada: res[1],
                    excel: true,
                });
            }
        }
    }
}

export default MarcasRelojMensual